import { link } from '../router';

export type Schritt = 'eckdaten' | 'vorgaben' | 'planung' | 'kraefte' | 'ausgabe';

const SCHRITTE: { key: Schritt; text: string }[] = [
  { key: 'eckdaten', text: 'Eckdaten' },
  { key: 'vorgaben', text: 'Vorgaben übernehmen' },
  { key: 'planung', text: 'Route & Abgleich' },
  { key: 'kraefte', text: 'Kräfte zuordnen' },
  { key: 'ausgabe', text: 'Ausgeben' },
];

/** Geführter Ablauf als Schrittleiste (Eckdaten → Vorgaben → Route & Abgleich → Kräfte → Ausgeben). */
export function Schritte({ id, aktiv, titel }: { id: string; aktiv: Schritt; titel?: string }) {
  return (
    <nav className="schritte" aria-label="Planungsschritte">
      {titel && <span className="schritte__titel">{titel}</span>}
      <ol>
        {SCHRITTE.map((s, i) => (
          <li key={s.key}>
            <a href={link('v', id, s.key)} aria-current={s.key === aktiv ? 'step' : undefined}>
              <span className="schritte__nr">{i + 1}</span> {s.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}
